export class EventReservationAction {

  /**
   * Edit an existing reservation
   *
   * @type {string}
   */
  static readonly EDIT_RESERVATION = 'EDIT_RESERVATION';
  /**
   * Create a reservation for a RSVP
   *
   * @type {string}
   */
  static readonly RSVP_CONFIRMATION = 'RSVP_CONFIRMATION';
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/event-reservation-action.ts